import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Grid,
  IconButton,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Close, Add, Delete } from '@mui/icons-material';

const SolicitudFormModal = ({ open, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    tipo: 'FISICA',
    prioridad: 'MEDIA',
    observaciones: '',
  });
  const [documentos, setDocumentos] = useState([{ nombre: '', tipoDocumento: '', caja: '', carpeta: '' }]);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDocChange = (index, field, value) => {
    const updated = [...documentos];
    updated[index][field] = value;
    setDocumentos(updated);
  };

  const addDocument = () => {
    setDocumentos([...documentos, { nombre: '', tipoDocumento: '', caja: '', carpeta: '' }]);
  };

  const removeDocument = (index) => {
    if (documentos.length <= 1) return;
    setDocumentos(documentos.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const validDocs = documentos.filter((d) => d.nombre.trim());
      await onSubmit({ ...formData, documentos: validDocs });
      setFormData({ tipo: 'FISICA', prioridad: 'MEDIA', observaciones: '' });
      setDocumentos([{ nombre: '', tipoDocumento: '', caja: '', carpeta: '' }]);
      onClose();
    } catch {
      // error handled by parent
    } finally {
      setSubmitting(false);
    }
  };

  const isValid = documentos.some((d) => d.nombre.trim());

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600}>Nueva Solicitud</Typography>
          <IconButton onClick={onClose} size="small"><Close /></IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2.5}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              select
              label="Tipo"
              name="tipo"
              value={formData.tipo}
              onChange={handleChange}
            >
              <MenuItem value="FISICA">Fisica</MenuItem>
              <MenuItem value="DIGITAL">Digital</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              select
              label="Prioridad"
              name="prioridad"
              value={formData.prioridad}
              onChange={handleChange}
            >
              <MenuItem value="BAJA">Baja</MenuItem>
              <MenuItem value="MEDIA">Media</MenuItem>
              <MenuItem value="ALTA">Alta</MenuItem>
              <MenuItem value="URGENTE">Urgente</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Observaciones"
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
              <Typography variant="subtitle2" fontWeight={600}>Documentos Solicitados</Typography>
              <Button size="small" startIcon={<Add />} onClick={addDocument}>Agregar</Button>
            </Box>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre *</TableCell>
                    <TableCell>Tipo Doc.</TableCell>
                    <TableCell>Caja</TableCell>
                    <TableCell>Carpeta</TableCell>
                    <TableCell width={50} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {documentos.map((doc, idx) => (
                    <TableRow key={idx}>
                      <TableCell>
                        <TextField
                          size="small"
                          fullWidth
                          value={doc.nombre}
                          onChange={(e) => handleDocChange(idx, 'nombre', e.target.value)}
                          placeholder="Nombre del documento"
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          fullWidth
                          value={doc.tipoDocumento}
                          onChange={(e) => handleDocChange(idx, 'tipoDocumento', e.target.value)}
                          placeholder="Tipo"
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          fullWidth
                          value={doc.caja}
                          onChange={(e) => handleDocChange(idx, 'caja', e.target.value)}
                          placeholder="Caja"
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          size="small"
                          fullWidth
                          value={doc.carpeta}
                          onChange={(e) => handleDocChange(idx, 'carpeta', e.target.value)}
                          placeholder="Carpeta"
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton size="small" onClick={() => removeDocument(idx)} disabled={documentos.length <= 1}>
                          <Delete fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={!isValid || submitting}>
          Crear Solicitud
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SolicitudFormModal;
